'use client'

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react'
import { SessionProvider } from '@/context/SessionContext'
import { AuthProvider } from '@/context/AuthContext'
import PetContextWrapper from '@/components/PetContextWrapper'
import { CartProvider } from '@/context/CartContext'
import { NotificationProvider } from '@/context/NotificationContext'
import ClientLayout from './ClientLayout'
import GlobalErrorHandler from '@/lib/globalErrorHandler'
import React, { useEffect } from 'react'

export function ClientProviders({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize global error handlers
    GlobalErrorHandler.initialize();
  }, []);

  return (
    <NextAuthSessionProvider
      refetchInterval={0}
      refetchOnWindowFocus={false}
      refetchWhenOffline={false}
    >
      <SessionProvider>
        <AuthProvider>
          <PetContextWrapper>
            <CartProvider>
              <NotificationProvider>
                <ClientLayout>
                  {children}
                </ClientLayout>
              </NotificationProvider>
            </CartProvider>
          </PetContextWrapper>
        </AuthProvider>
      </SessionProvider>
    </NextAuthSessionProvider>
  )
}
